import { columnApprovers } from "commonComponents/utilities/Grid/approvals/columnImplementations/columnApprovers";
import { columnBillAccountingStatus } from "commonComponents/utilities/Grid/bill/columnImplementations/columnBillAccountingStatus";
import { columnBillAmount } from "commonComponents/utilities/Grid/bill/columnImplementations/columnBillAmount";
import { columnBillDocumentType } from "commonComponents/utilities/Grid/bill/columnImplementations/columnBillDocumentType";
import { columnBillLink } from "commonComponents/utilities/Grid/bill/columnImplementations/columnBillLink";
import { columnBillPayTo } from "commonComponents/utilities/Grid/bill/columnImplementations/columnBillPayTo";
import { columnBillStatus } from "commonComponents/utilities/Grid/bill/columnImplementations/columnBillStatus";
import { columnLienWaiverStatus } from "commonComponents/utilities/Grid/bill/columnImplementations/columnLienWaiverStatus";
import { columnLinkedScheduleItemStatus } from "commonComponents/utilities/Grid/bill/columnImplementations/columnLinkedScheduleItemStatus";
import { columnRelatedPurchaseOrderLinks } from "commonComponents/utilities/Grid/bill/columnImplementations/columnRelatedPurchaseOrders";
import { type IClientGridColumn } from "commonComponents/utilities/Grid/GridContainer.types";

// One stable module-level array. Returning a fresh array on every call would cause
// the grid to see new column references each render and remount its header cells,
// which races with E2E sort-header assertions. The bill-link/lien-waiver columns
// pick absolute vs relative navigation from BillLinkAbsoluteContext at render time,
// so a single array serves both the modal and full-page list experiences.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const billColumns: IClientGridColumn<any>[] = [
    columnBillAmount,
    columnBillLink,
    columnLienWaiverStatus,
    columnLinkedScheduleItemStatus,
    columnRelatedPurchaseOrderLinks,
    columnBillAccountingStatus,
    columnBillPayTo,
    columnBillDocumentType,
    columnBillStatus,
    columnApprovers,
];

/**
 * Column implementations for the Bill grid. Wrap the grid in a
 * {@link BillLinkAbsoluteContext} provider to control whether bill links open
 * full-page (true) or as a modal (false); it defaults to modal without a provider.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getBillColumnImplementations = (): IClientGridColumn<any>[] => billColumns;
